import Encounter from './encounter.js';
import Order from './order.js';
import Patient from './patient.js';
import { BaseAPI, type Common } from '../../common.js';

export default class API extends BaseAPI {
  Encounter: Encounter;
  Order: Order;
  Patient: Patient;

  constructor(common: Common) {
    super(common);
    this.Encounter = new Encounter(common);
    this.Order = new Order(common);
    this.Patient = new Patient(common);
  }
}
